import Controller from './controller';

App.Widgets.setWidgetStarterInNamespace('WidgetCompactFooter', Controller);



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-compact-footer/scripts/index.js